import { ChangeDetectionStrategy, Component, OnInit, signal } from '@angular/core';
import { ExerciseDb } from 'lib/cosmos/exercise/exerciseDb.js';
import { isNotUndefined } from 'lib/helpers/array.utils';
import { ExerciseListItem } from 'lib/ui/list/select-exercise-list.component';
import { map } from 'rxjs';
import { TypeCoreComponent } from 'src/app/pages/type-routes/type-core.component.js';
import { ExerciseUtilsService } from './services/exercise-utils.service';

@Component({
	templateUrl: './list-global-exercises.component.html',
	selector: 'mod-list-global-exercises',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class ListGlobalExercisesComponent extends TypeCoreComponent implements OnInit {
	public readonly exerciseItems = signal<readonly ExerciseListItem[] | undefined>(undefined);

	constructor(private readonly exerciseUtilsService: ExerciseUtilsService) {
		super();

		this.dataInit = () => {
			this.initExercises();
		};
	}

	private initExercises(): void {
		super.subscribeToObservable(
			this.dependencies.httpService.listGlobal<ExerciseDb.IExerciseItem>('exercise').pipe(
				map((response) => {
					this.exerciseItems.set(
						response.data.map<ExerciseListItem>((m) => ({
							id: m.id,
							isGlobal: m.system.isGlobal,
							name: m.system.name,
							images: m.images?.map((m) => m.image).filter(isNotUndefined) ?? [],
							videoUrl: m.videoUrl,
							equipment: m.equipment,
							difficulty: m.difficulty,
							instructions: m.instructions,
							forceType: m.forceType,
							laterality: m.laterality,
							targetMuscleGroup: m.targetMuscleGroup,
							select: () => {
								this.exerciseUtilsService.openExerciseInstructionDialog({
									images: m.images?.map((m) => m.image).filter(isNotUndefined) ?? [],
									name: m.system.name,
									equipment: m.equipment,
									categories: m.categories,
									videoUrl: m.videoUrl,
									source: m.source,
									instructions: m.instructions,
									targetMuscleGroup: m.targetMuscleGroup,
									forceType: m.forceType,
									laterality: m.laterality,
									difficulty: m.difficulty
								});
							}
						}))
					);
				})
			)
		);
	}
}
